import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=0cbaba9c&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=0cbaba9c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cbaba9c')) {
      api.createRecord('0cbaba9c', component.options)
    } else {
      api.reload('0cbaba9c', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=0cbaba9c&", function () {
      api.rerender('0cbaba9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/leads/Add/Main.vue"
export default component.exports